import axios from "axios";

class Faq {
    constructor() {
        this.questions = document.querySelectorAll(".faq-tax__question");
        this.searchInput = document.querySelector(".faq__search-input");
        this.searchInit = document.querySelector(".faq__search-btn");
        this.resultContainer = document.querySelector("#faq_results");
        this.searchValue = "";
        this.events();
    }

    events() {
        this.questions.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.currentTarget.classList.toggle("open");
            });
        });

        if (this.searchInput) {
            this.searchInput.addEventListener("blur", (e) => {
                this.searchValue = e.target.value;
                this.searchQuestions();
            });

            this.searchInput.addEventListener("keyup", (e) => {
                if (e.keyCode === 13) {
                    this.searchValue = e.target.value;
                    this.searchQuestions();
                }
            });

            this.searchInit.addEventListener("click", (e) => {
                this.searchValue = this.searchInput.value;
                this.searchQuestions();
            });
        }
    }

    searchQuestions() {

        const data = new FormData();

        data.append("action", "searchFaq");
        data.append("search", this.searchValue);
        axios
            .post(ajax.ajax_url, data)
            .then((res) => {
                this.resultContainer.innerHTML = JSON.parse(res.data.data);
                this.questions =
                    document.querySelectorAll(".faq-tax__question");
                this.questions.forEach((el) => {
                    el.addEventListener("click", (e) => {
                        e.currentTarget.classList.toggle("open");
                    });
                });
            })
            .catch((err) => {
            });
    }
}

export default Faq;
